<template>
  <div class="odmik-vsebine-soglasja">
    <div>
      <p class="navadno-besedilo">
        Soglasja uporabljamo za zagotavljanje ustreznejših storitev in informacij našim obiskovalcem. 
        Dano soglasje za obdelavo osebnih podatkov lahko prekličete kadarkoli. 
        Prekličete lahko pravico za posamezen namen ali za vse namene obdelave osebnih podatkov, s katerimi ste soglašali.
      </p>
    </div>
    <div style="padding-top: 10px">
      <p class="navadno-besedilo">
        Več informacij o varstvu osebnih podatkov boste našli
        <a href="https://www.t-2.net/varnost-osebnih-podatkov" style="color:#EF7D00" target="_blank">tukaj</a>.
      </p>
    </div>
    <div style="padding-top: 40px" v-loading="pridobivanjeSoglasij">
      <div v-for="(soglasje, index) in soglasja">
        <div>
          <ul>
            <li>
              <img :src="soglasje.ikona">
              <span class="open-sans-20pt">
              {{ soglasje.naziv }}
            </span>
            </li>
          </ul>
        </div>
        <div class="odmik-vsebine-od-naslova">
          <p class="navadno-besedilo">
            {{ soglasje.opis}}
          </p>
        </div>
        <div class="odmik-soglasja">
          <span class="postavitev-soglasja">
            <el-checkbox v-model="soglasje.soglasam" v-bind:key="soglasje.idTip">
            </el-checkbox>
          </span>
          <span class="navadno-besedilo flex-odmik">
            {{soglasje.soglasje}}
          </span>
        </div>
        <div class="odmik-hr">
          <hr class="hr-stil">
        </div>
      </div>
    </div>
    <div class="postavitev-gumbov">
      <p>
        <el-button class="gumb-potrdi" type="primary" @click="AddConsents">
          SHRANI SPREMEMBE
        </el-button>
        <a class="stil-gumb-preklici" @click="GetConsents" type="primary">
          PREKLIČI
        </a>
      </p>
    </div>
  </div>
</template>
<script>
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {Checkbox, Button} from 'element-ui'

export default {
  name: 'SoglasjaProfil',
  mixins: [SirinaOkna],
  data () {
    return {
      clientAgent: null,
      soglasja: [],
      pridobivanjeSoglasij: false
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetConsents()
  },
  watch: {
    orientacija: function (val) {
      this.formaOrientacija = val
    }
  },
  methods: {
    GetConsents () {
      this.pridobivanjeSoglasij = true
      let param = []
      this.soglasja = []
      this.clientAgent.postWsRequest(
        this,
        'user/getConsents',
        param,
        null,
        'SetConsents',
        'ErrConsents')
    },
    SetConsents (podatki) {
      for (let soglasja in podatki.data) {
        this.soglasja.push(podatki.data[soglasja])
      }
      this.pridobivanjeSoglasij = false
    },
    ErrConsents (podatki) {
      this.pridobivanjeSoglasij = false
      this.ShowWarningMessage(podatki)
    },
    AddConsents () {
      this.posameznoSoglasje = []
      let param = []
      for (let key in this.soglasja) {
        this.posameznoSoglasje.push(this.soglasja[key])
      }
      for (let i = 0; i < this.posameznoSoglasje.length; i++) {
        param.push('consents' + '[' + this.posameznoSoglasje[i].idTip + ']=' + this.posameznoSoglasje[i].soglasam)
      }
      this.clientAgent.postWsRequest(
        this,
        'user/addConsents',
        param,
        null,
        'SetAddConsents',
        'ErrAddConsents')
    },
    SetAddConsents (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljeni podatki.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetConsents()
    },
    ErrAddConsents (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/moj_profil/SoglasjaProfil.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/UrejanjeProfila/SoglasjaProfil.vue